import { AnalyticsPage } from '../Analytics/AnalyticsPage';

export function MyAnalyticsPage() {
  return <AnalyticsPage platformTitle="My Analytics" />;
}
